import type { BaseCabItemOption } from '@/api';

export const getCabAttributes = (cabOption: BaseCabItemOption) => {
	const { displayPrice, strikePrice = displayPrice } = cabOption.pricing;
	return {
		'Cab Type': cabOption.vehicleType,
		'Fuel Type': cabOption.fuelType,
		Fare: strikePrice,
	};
};

/**
 * True when the cab offers partial payment in at least one of the burn /
 * no-burn blocks. Drives the "Partial payment option available on this cab"
 * footnote in the cab-selection bottomsheet.
 */
export const cabSupportsPartialPay = (cab: BaseCabItemOption): boolean =>
	[cab.paymentOptionsWithBurn, cab.paymentOptionsWithoutBurn].some((block) =>
		block?.plans.some((plan) => plan.type === 'PART_PAY'),
	);
